<template>
	<v-card flat class="mb-3">
		<v-toolbar flat dense color="primary">
			<v-toolbar-title class="title white--text" style="margin: 0 10px">
				<v-btn icon @click="yearChange(-1)" small>
					<v-icon small color="white">far fa-arrow-to-left</v-icon>
				</v-btn>
				{{year}}
				<v-btn icon @click="yearChange(1)" :disabled="thisYear" color="white" small>
					<v-icon small color="white">far fa-arrow-to-right</v-icon>
				</v-btn>
			</v-toolbar-title>
			<v-icon color="white" v-if="refreshing">fa-spin fa-spinner</v-icon>

			<v-spacer></v-spacer>
	<v-toolbar-items>
			<v-tabs
				v-model="yearView"
				centered
				slider-color="cyan"
			>
				<v-tab
					href="#completed"
				>
					Completed
				</v-tab>
				<v-tab
					href="#error"
				>
					Errors
				</v-tab>
			</v-tabs>
	</v-toolbar-items>

		</v-toolbar>

		<v-divider></v-divider>

		<v-card-text>
			<div class="caption mb-3 info--text">Click to view day</div>
			<calendar-heatmap v-if="yearView === 'completed'" @day-click="clicked" :values="chartComplete" :end-date="endDate" :range-color="greenColors" tooltip-unit="completed" />
			<calendar-heatmap v-else :values="chartErrors" @day-click="clicked" :end-date="endDate" :range-color="redColors" tooltip-unit="errors" />
		</v-card-text>
	</v-card>
</template>

<script>
import { DateTime }	from "luxon";
import api from "../../api";

export default {
	props: {
		region: String,
	},
	data() {
		return {
			refreshing: false,
			year: null,
			chartComplete: [],
			chartErrors: [],
			greenColors: ["#ebedf0", "#C8E6C9", "#81C784", "#4CAF50", "#388E3C", "#1B5E20"],
			redColors: ["#ebedf0", "#FFCDD2", "#E57373", "#F44336", "#D32F2F", "#B71C1C"],
			yearView: "completed",
		};
	},
	created() {
		this.year = this.dtnow().year;
		this.refresh();
	},
	computed: {
		endDate() {
			return new Date(this.year + 1, 0, 1);
		},
		thisYear() {
			return this.year === this.dtnow().year;
		},
	},
	methods: {
		refresh() {
			this.refreshing = true;
			api.dailyCounts({ year: this.year, region: this.region, offset: this.dtnow().offset }).then((r) => {
				this.chartComplete = r.data.completed;
				this.chartErrors = r.data.errors;
				this.refreshing = false;
			}).catch((e) => {
				this.showError(e);
			});
		},
		yearChange(amt) {
			this.year += amt;
			this.refresh();
		},
		clicked(e) {
			this.$emit("day-click", DateTime.fromJSDate(e.date));
		},
	},
};
</script>
